<!-- CustomersIndex.vue -->
<template>
  <SubNavCardVue :buttons="buttons">
    <router-view></router-view>
  </SubNavCardVue>
</template>

<script>
import SubNavCardVue from '@/components/cards/SubNavCard.vue'

export default {
  components: { SubNavCardVue },
  data() {
    return {
      buttons: [
        {
          label: 'Liste des Clients',
          icon: 'bi bi-people',
          route: 'customers-index'
        },
        // {
        //   label: 'Créer un Client',
        //   icon: 'bi bi-person-plus',
        //   route: 'customers-create'
        // },
        {
          label: 'Types de Comptes',
          icon: 'bi bi-diagram-2',
          route: 'customers-types-index'
        },
        // {
        //   label: 'Créer un Type',
        //   icon: 'bi bi-plus-circle',
        //   route: 'customers-types-create'
        // },
        // {
        //   label: 'Vendeurs',
        //   icon: 'bi bi-person-badge',
        //   route: 'customers-sellers-index'
        // },
        // Les routes "edit" et "details" ne sont pas mises ici 
        // car elles concernent des actions sur un client spécifique
      ]
    }
  }
}
</script>
